// extracted by mini-css-extract-plugin
export default {"tooltip":"hR-z","arrow":"iR-z"};